var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 571.531,
    height: 171.743,
    viewBox: "0 0 571.531 171.743",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(-680 -1988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M391.93,103.32h6.21v7.84h-6.21Z",
    transform: "translate(680 1988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M425.63,73v3.91h-7.76v25.73a8.32,8.32,0,0,0,.63,3.58c.42.86,1.47,1.34,3.14,1.44a35.569,35.569,0,0,0,4-.22v3.92a20.453,20.453,0,0,0-2.07.07,20.266,20.266,0,0,1-2.06.08q-4.67,0-6.51-1.81t-1.78-6.7V76.93h-6.66V73h6.66V61.56h4.65V73Z",
    transform: "translate(680 1988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M437.39,73v9h.15a14.56,14.56,0,0,1,5.5-7.17A14.38,14.38,0,0,1,452,72.5v4.65a14.33,14.33,0,0,0-5.77.85,13.15,13.15,0,0,0-4.47,2.85,12.93,12.93,0,0,0-2.92,4.4,14.7,14.7,0,0,0-1,5.58v20.33H433.1V73Z",
    transform: "translate(680 1988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M458.08,78.93a10.83,10.83,0,0,1,3.22-4,13.39,13.39,0,0,1,4.77-2.29,22.87,22.87,0,0,1,6.06-.74,26.85,26.85,0,0,1,5,.48,12.08,12.08,0,0,1,4.5,1.81,9.84,9.84,0,0,1,3.26,3.73,13.59,13.59,0,0,1,1.25,6.25v20.25c0,1.88.92,2.81,2.74,2.81a3.59,3.59,0,0,0,1.48-.3v3.92c-.55.1-1,.18-1.44.22a13.72,13.72,0,0,1-1.59.08,7,7,0,0,1-2.85-.48,3.77,3.77,0,0,1-1.66-1.37,5,5,0,0,1-.78-2.11,18.468,18.468,0,0,1-.18-2.69h-.15a31.7,31.7,0,0,1-2.55,3.28,12.239,12.239,0,0,1-2.89,2.41,13.41,13.41,0,0,1-3.62,1.48,20.069,20.069,0,0,1-4.84.51,19.05,19.05,0,0,1-5-.63,11.14,11.14,0,0,1-4.07-2,9.63,9.63,0,0,1-2.73-3.48,11.45,11.45,0,0,1-1-5,9.8,9.8,0,0,1,1.78-6.24,11.22,11.22,0,0,1,4.69-3.44,26.74,26.74,0,0,1,6.58-1.66q3.66-.48,7.43-.93a24.362,24.362,0,0,0,2.59-.37,4.34,4.34,0,0,0,1.84-.77,3.56,3.56,0,0,0,1.15-1.52,6.54,6.54,0,0,0,.41-2.51,8.45,8.45,0,0,0-.78-3.88,6.151,6.151,0,0,0-2.14-2.4,8.68,8.68,0,0,0-3.18-1.22,21.64,21.64,0,0,0-3.88-.34,11.81,11.81,0,0,0-7.25,2.11c-1.87,1.41-2.86,3.66-3,6.76h-4.66a15.539,15.539,0,0,1,1.49-5.73Zm23.29,11.38a2.67,2.67,0,0,1-1.7,1.19,18.782,18.782,0,0,1-2.22.51q-3,.52-6.1.93a32.82,32.82,0,0,0-5.73,1.22,11.33,11.33,0,0,0-4.25,2.32,5.56,5.56,0,0,0-1.66,4.33,6.749,6.749,0,0,0,.7,3.14,7.74,7.74,0,0,0,1.89,2.37,8.16,8.16,0,0,0,2.73,1.51,9.9,9.9,0,0,0,3.18.52,16.11,16.11,0,0,0,5.1-.81,12.5,12.5,0,0,0,4.25-2.37,11.31,11.31,0,0,0,4-8.8V90.31Z",
    transform: "translate(680 1988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M525.5,111.16v-7.25h-.15a10.78,10.78,0,0,1-2.18,3.4,14,14,0,0,1-3.29,2.63,17,17,0,0,1-4,1.66,15.231,15.231,0,0,1-4.18.59,16.94,16.94,0,0,1-7.58-1.59,15.2,15.2,0,0,1-5.36-4.36,18.689,18.689,0,0,1-3.17-6.43,29.209,29.209,0,0,1,0-15.45,18.69,18.69,0,0,1,3.17-6.43,15.64,15.64,0,0,1,5.36-4.4,16.67,16.67,0,0,1,7.58-1.62,17.149,17.149,0,0,1,4.18.51,14.3,14.3,0,0,1,3.8,1.59,13.491,13.491,0,0,1,3.15,2.63,10.932,10.932,0,0,1,2.1,3.62h.15V58.38h4.66v52.78ZM500,98a16.179,16.179,0,0,0,2.22,5.21,12.159,12.159,0,0,0,3.88,3.74,10.71,10.71,0,0,0,5.69,1.44,12.56,12.56,0,0,0,6.25-1.44,12.341,12.341,0,0,0,4.14-3.74A15.46,15.46,0,0,0,524.43,98a25,25,0,0,0,0-11.75A15.551,15.551,0,0,0,522.14,81,12.31,12.31,0,0,0,518,77.27a12.45,12.45,0,0,0-6.25-1.45,10.62,10.62,0,0,0-5.69,1.45A12.13,12.13,0,0,0,502.18,81,16.28,16.28,0,0,0,500,86.21,25,25,0,0,0,500,98Z",
    transform: "translate(680 1988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M542.83,98.55a14.31,14.31,0,0,0,2.26,4.85,12.711,12.711,0,0,0,3.92,3.54,10.89,10.89,0,0,0,5.69,1.41q5.1,0,8-2.66a14,14,0,0,0,4-7.1h4.66a18.62,18.62,0,0,1-5.43,10q-4,3.56-11.2,3.55a17.74,17.74,0,0,1-7.8-1.59,14.37,14.37,0,0,1-5.36-4.36,19.071,19.071,0,0,1-3.07-6.43,29.433,29.433,0,0,1-1-7.72,28,28,0,0,1,1-7.4,19.879,19.879,0,0,1,3.07-6.46,15.44,15.44,0,0,1,5.36-4.59,16.57,16.57,0,0,1,7.8-1.73,15.05,15.05,0,0,1,13.12,6.69,20,20,0,0,1,2.92,6.87,30.159,30.159,0,0,1,.74,7.87H542.13a20.49,20.49,0,0,0,.7,5.26ZM565.9,84.33A14,14,0,0,0,563.49,80a11.411,11.411,0,0,0-17.66,0,15.129,15.129,0,0,0-2.48,4.36,21.311,21.311,0,0,0-1.22,5.07h24.69A17,17,0,0,0,565.9,84.33Z",
    transform: "translate(680 1988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M361.58,33.72l8.21-.28s7.28-.57,7.28-8.72V18.34h-9.18L383.68,0l15.87,18.34h-8.82c1.67,30.14-20.89,28-20.89,28h-8.36Z",
    transform: "translate(680 1988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M157.1,33.22h13.3V76.74c0,24.13-11.9,35.49-42.14,35.49-30,0-42-11.36-42-35.49V33.22h14V76.74c0,15.66,7,22.09,28.41,22.09S157.1,92.4,157.1,76.74Z",
    transform: "translate(680 1988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M279.63,111.64l-14.9-54.78-22.09,50.7c-1.5,3.33-3.64,5.15-7,5.15s-5.58-1.82-7-5.15l-22-50.7-14.9,54.78h-13.4l20-73.33c1-3.76,3.11-5.58,6.76-5.58a7.36,7.36,0,0,1,6.86,4.61l24,55.11,24-55.11a6.94,6.94,0,0,1,6.54-4.61c3.32,0,5.47,1.82,6.54,5.58l19.94,73.33Z",
    transform: "translate(680 1988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M0,111.16V97.54H28.52c18.22,0,25.62-6.75,25.62-21.87V33.22H67.76V75.67c0,24.12-12.12,35.49-39.24,35.49Z",
    transform: "translate(680 1988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M318.72,33.22H305.17v77.94h13.51V46.83h.04Z",
    transform: "translate(680 1988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M360,33.22H346.69a6.59,6.59,0,0,0-6.59,6.59v.43a6.59,6.59,0,0,0,6.59,6.59H360c9.54,0,15.22,5.68,15.22,14.69,0,8.79-5.68,14.79-15.22,14.79H317.12c-3.64,0-2.9,3-2.9,6.6h0c0,3.64-.74,6.59,2.9,6.59H360c18,0,28.51-11.58,28.51-28.41C388.47,44,378,33.22,360,33.22Z",
    transform: "translate(680 1988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(-251.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M251.36,163.29c0-4.14,2.71-8.25,8.16-8.25a9.2,9.2,0,0,1,4.48,1.42.28.28,0,0,1,.06.41l-1.22,1.74a.25.25,0,0,1-.4.07,5,5,0,0,0-2.9-1c-7.12,0-7.12,11.12,0,11.12.88,0,2.65-.14,2.65-1.36v-.23a.27.27,0,0,1,.29-.29h2.15a.27.27,0,0,1,.29.29v2.08a.68.68,0,0,1-.22.48,9,9,0,0,1-5.18,1.71C254.07,171.53,251.36,167.4,251.36,163.29Zm7.12,1.51v-1.94a.28.28,0,0,1,.29-.3h5.86a.28.28,0,0,1,.29.3v1.94a.27.27,0,0,1-.29.29h-5.86a.27.27,0,0,1-.29-.29Z",
    transform: "translate(680 1988)",
    fill: "#ede811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M272.43,170.9V155.49a.1.1,0,0,1,.11-.11h5.54c5.42.5,6.12,6.76,2.19,8.86a.49.49,0,0,0-.23.77L284.2,171c.11.16,0,.25-.14.25h-2.64A.57.57,0,0,1,281,171l-4.05-5.83a1,1,0,0,1-.18-.52v-2a.27.27,0,0,1,.29-.29h.41c3.43,0,3.41-4.41,0-4.41h-1.65a.61.61,0,0,0-.63.66V170.9a.28.28,0,0,1-.3.3h-2.12a.28.28,0,0,1-.34-.3Z",
    transform: "translate(680 1988)",
    fill: "#ede811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M299,155a8.27,8.27,0,1,1-8.16,8.27A7.88,7.88,0,0,1,299,155Zm0,13.8a5.54,5.54,0,1,0-5.49-5.53,5.29,5.29,0,0,0,5.49,5.55Zm-1.85-5.74,1.65-1.65a.27.27,0,0,1,.4,0l1.65,1.65a.28.28,0,0,1,0,.41l-1.65,1.65a.26.26,0,0,1-.4,0l-1.65-1.65a.25.25,0,0,1-.02-.39Z",
    transform: "translate(680 1988)",
    fill: "#ede811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M313.87,155.38h2.29a.43.43,0,0,1,.4.27l3.75,9c.07.19.19.28.28.28s.15-.09.24-.28l3.26-7.36a.39.39,0,0,1,.34-.21.38.38,0,0,1,.34.21l4.9,11a.72.72,0,0,1,0,.54l-1,2.35a.36.36,0,0,1-.32.2.37.37,0,0,1-.34-.2l-3.36-7.75c-.07-.16-.16-.25-.25-.25s-.18.07-.25.25l-3.37,7.75a.35.35,0,0,1-.31.2.36.36,0,0,1-.34-.2l-6.47-15.57C313.63,155.49,313.69,155.38,313.87,155.38Zm15.39,7.55,3.05-7.28a.45.45,0,0,1,.41-.27H335c.18,0,.25.11.18.27l-4.38,10.6c-.07.16-.16.16-.23,0l-1.29-2.78a.83.83,0,0,1-.02-.54Z",
    transform: "translate(680 1988)",
    fill: "#ede811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M351.25,155.38h2.29a.43.43,0,0,1,.4.27l3.75,9c.07.19.19.28.28.28s.15-.09.24-.28l3.26-7.36a.39.39,0,0,1,.34-.21.38.38,0,0,1,.34.21l3.25,7.36c.09.19.18.28.27.28s.18-.09.25-.28l3.77-9a.45.45,0,0,1,.41-.27h2.26c.18,0,.25.11.18.27l-6.46,15.57a.36.36,0,0,1-.32.2.37.37,0,0,1-.34-.2l-3.36-7.75c-.07-.16-.16-.25-.25-.25s-.18.07-.25.25l-3.37,7.75a.35.35,0,0,1-.31.2.36.36,0,0,1-.34-.2l-6.47-15.57C351,155.49,351.07,155.38,351.25,155.38Z",
    transform: "translate(680 1988)",
    fill: "#ede811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M379.77,155.38h2.13a.27.27,0,0,1,.29.29V170.9a.28.28,0,0,1-.29.3h-2.13a.28.28,0,0,1-.29-.3V155.67a.27.27,0,0,1,.29-.29Z",
    transform: "translate(680 1988)",
    fill: "#ede811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M389,157.61v-1.94a.27.27,0,0,1,.29-.29h12.43a.27.27,0,0,1,.29.29v1.94a.27.27,0,0,1-.29.3h-4.23a.61.61,0,0,0-.65.63V170.9a.28.28,0,0,1-.29.3h-2.13a.29.29,0,0,1-.29-.3V158.54a.6.6,0,0,0-.64-.63h-4.2a.27.27,0,0,1-.29-.3Z",
    transform: "translate(680 1988)",
    fill: "#ede811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M409.15,155.38h2.13a.27.27,0,0,1,.29.29v5.72a.6.6,0,0,0,.64.63h6.28a.59.59,0,0,0,.63-.63v-5.72a.28.28,0,0,1,.29-.29h2.13a.27.27,0,0,1,.29.29V170.9a.28.28,0,0,1-.29.3h-2.13a.29.29,0,0,1-.29-.3v-5.71a.6.6,0,0,0-.63-.64h-6.28a.6.6,0,0,0-.64.64v5.71a.28.28,0,0,1-.29.3h-2.13a.28.28,0,0,1-.29-.3V155.67a.27.27,0,0,1,.29-.29Z",
    transform: "translate(680 1988)",
    fill: "#ede811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M438.53,170.92l7.14-15.57a.41.41,0,0,1,.34-.2.35.35,0,0,1,.32.2l7.14,15.57c.07.16,0,.28-.18.28h-2.21a.49.49,0,0,1-.43-.28l-.64-1.37a1,1,0,0,0-.9-.57H442.9a1,1,0,0,0-.91.57l-.63,1.37a.48.48,0,0,1-.41.28h-2.23C438.53,171.2,438.47,171.08,438.53,170.92Zm5.54-4.47H448c.38,0,.52-.23.36-.59l-2-4.43c-.09-.18-.19-.27-.28-.27s-.18.09-.27.27l-2.05,4.43C443.53,166.22,443.69,166.45,444.07,166.45Z",
    transform: "translate(680 1988)",
    fill: "#ede811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M457.16,157.61v-1.94a.27.27,0,0,1,.29-.29h12.43a.27.27,0,0,1,.29.29v1.94a.27.27,0,0,1-.29.3h-4.23a.61.61,0,0,0-.65.63V170.9a.28.28,0,0,1-.3.3h-2.12a.29.29,0,0,1-.29-.3V158.54a.6.6,0,0,0-.64-.63h-4.2a.27.27,0,0,1-.29-.3Z",
    transform: "translate(680 1988)",
    fill: "#ede811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M476.09,157.61v-1.94a.28.28,0,0,1,.3-.29h12.43a.27.27,0,0,1,.29.29v1.94a.27.27,0,0,1-.29.3h-4.23a.61.61,0,0,0-.65.63V170.9a.28.28,0,0,1-.3.3h-2.12a.29.29,0,0,1-.3-.3V158.54a.59.59,0,0,0-.63-.63h-4.2a.28.28,0,0,1-.3-.3Z",
    transform: "translate(680 1988)",
    fill: "#ede811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M496.23,155.38h2.13a.27.27,0,0,1,.29.29V170.9a.28.28,0,0,1-.29.3h-2.13a.28.28,0,0,1-.29-.3V155.67a.27.27,0,0,1,.29-.29Z",
    transform: "translate(680 1988)",
    fill: "#ede811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M505.47,157.61v-1.94a.28.28,0,0,1,.3-.29H518.2a.27.27,0,0,1,.29.29v1.94a.27.27,0,0,1-.29.3H514a.61.61,0,0,0-.65.63V170.9a.28.28,0,0,1-.3.3H510.9a.29.29,0,0,1-.3-.3V158.54a.59.59,0,0,0-.63-.63h-4.2a.28.28,0,0,1-.3-.3Z",
    transform: "translate(680 1988)",
    fill: "#ede811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M531.49,171.74a6.23,6.23,0,0,1-6.4-6.55v-9.52a.27.27,0,0,1,.29-.29h2.13a.27.27,0,0,1,.29.29v9.52a3.69,3.69,0,0,0,7.37,0v-9.52a.27.27,0,0,1,.29-.29h2.13a.28.28,0,0,1,.29.29v9.52a6.21,6.21,0,0,1-6.39,6.55Z",
    transform: "translate(680 1988)",
    fill: "#ede811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M545.68,155.38h5.04a7.9,7.9,0,0,1,0,15.77h-5.04a.28.28,0,0,1-.29-.3V155.67a.27.27,0,0,1,.29-.29ZM548.1,168a.59.59,0,0,0,.63.63h1.88c6.48-.63,6.3-10.71-.66-10.71h-1.22a.59.59,0,0,0-.63.63Z",
    transform: "translate(680 1988)",
    fill: "#ede811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M565.52,155.67a.27.27,0,0,1,.3-.29h9.65a.27.27,0,0,1,.29.29v1.94a.27.27,0,0,1-.29.3h-6.6a.6.6,0,0,0-.64.63v2.85a.6.6,0,0,0,.64.63h5a.27.27,0,0,1,.29.3v1.94a.27.27,0,0,1-.29.29h-5a.6.6,0,0,0-.64.64V168a.59.59,0,0,0,.64.63h6.6a.28.28,0,0,1,.29.3v1.94a.28.28,0,0,1-.29.3h-9.65a.28.28,0,0,1-.3-.3Z",
    transform: "translate(680 1988)",
    fill: "#ede811"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJump);
export default __webpack_public_path__ + "static/media/jump.6140d117f4c1827a2d1a0f14b3b3bd34.svg";
export { ForwardRef as ReactComponent };